export default __webpack_public_path__ + "static/media/misc-drawerB-1920w.4aa6b7f9.avif";